import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-duplicate-filings",
  // imports: [],
  templateUrl: "./duplicate-filings.component.html",
  styleUrl: "./duplicate-filings.component.css",
  standalone: false,
})
export class DuplicateFilingsComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
